export enum FeatureFlag {
  BILLING_USAGE_REVAMP = 'billing-usage-revamp',
  CLOUD_COMPASS_CREDENTIAL = 'cloud-compass-credential',
  CLOUD_COMPASS_RENEWAL = 'cloud-compass-renewal',
  PROJECT_SIDEBAR_TREE = 'project-sidebar-tree'
}

export const localFeatureFlagValues = {
  [FeatureFlag.BILLING_USAGE_REVAMP]: false,
  [FeatureFlag.CLOUD_COMPASS_CREDENTIAL]: false,
  [FeatureFlag.CLOUD_COMPASS_RENEWAL]: false,
  [FeatureFlag.PROJECT_SIDEBAR_TREE]: false
};

export type FeatureFlags = typeof localFeatureFlagValues;

export const FEATURE_FLAG_OVERRIDES_STORAGE_KEY = 'ENV0_FEATURE_FLAG_OVERRIDES';

export const readFeatureFlagOverrides = (): Partial<FeatureFlags> => {
  try {
    const stored = localStorage.getItem(FEATURE_FLAG_OVERRIDES_STORAGE_KEY);
    return stored ? JSON.parse(stored) : {};
  } catch {
    return {};
  }
};
